import {Container, Col, Row }from 'react-bootstrap';

interface WrapperProps{
    children: React.ReactNode; 
}
function FormWrapper({children}: WrapperProps){
    return (
        <> 
            <Container className="color-bg-primary p-3 rounded">
                <Row>
                    <Col md={{ span: 4, offset:4 }} className="">
                        <div className="py-0 my-0">
                            <img className="color-fill-secondary branding-logo-small" src="/assets/logo-monochrome.svg" alt="Company Logo"  />
                        </div>
                    </Col>

                </Row>
                <Row>
                    {children}
                </Row>
            </Container>
        </>
    )
}

export default FormWrapper;